export interface MemoryPanelProps {
  onClose: () => void
}
